import * as Yup from 'yup';
import { SUPPORT_DOCUMENT_TYPES } from '../utils/fileTypes';

const FILE_SIZE = 50 * 1024;

export const crossReferenceInitialValues = (value, isNew) => {
  return {
    documentTitle: isNew ? null : value.documentTitle,
    referenceFieldLabel: isNew ? null : value.referenceFieldLabel,
    file: '',
  };
};

export const crossReferenceValidationSchema = (t) => Yup.object().shape({
  documentTitle: Yup.string().required(t('formulary.validation.document_title_required')),
  referenceFieldLabel: Yup.string().required(
    t('formulary.validation.reference_field_label_required')
  ),
  file: Yup.mixed()
    .test('fileSize', t('formulary.validation.file_too_large'), (value) => {
      if (!value) {
        return true;
      } else {
        const sizeComparison = Math.round(value.size / 1000) <= FILE_SIZE;
        return sizeComparison;
      }
    })
    .test('fileFormat', t('formulary.validation.unsupported_file_format'), (value) => {
      if (!value) {
        return true;
      } else return SUPPORT_DOCUMENT_TYPES.includes(value.type);
    }),
});
